var render = function render(_c,_vm){return _c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.props.item.dynamicFieldName)),(_vm.props.item.config == 1)?_c('span',{staticClass:"required ml6"},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }